<template>
    <span
      :class="[
        'label',
        `label--${color}`,
        `label--${variant}`,
        { 'label--start-icon': startIcon },
        { 'label--end-icon': endIcon },
      ]"
      :style="sx"
    >
      <span v-if="startIcon" class="label__icon" v-html="startIcon"></span>
      {{ children }}
      <span v-if="endIcon" class="label__icon" v-html="endIcon"></span>
    </span>
  </template>
  
  <script>
  export default {
    props: {
      children: String,
      startIcon: String,
      endIcon: String,
      color: {
        type: String,
        default: 'default',
        validator: (value) =>
          ['default', 'primary', 'secondary', 'info', 'success', 'warning', 'error'].includes(value),
      },
      variant: {
        type: String,
        default: 'ghost',
        validator: (value) => ['filled', 'outlined', 'ghost'].includes(value),
      },
      sx: Object,
    },
  };
  </script>
  
  <style scoped>
  /* Aquí puedes agregar tus estilos */
  </style>